/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-04 15:14:38
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Icon } from '@shopify/polaris';
import { CaretDownMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { stringifyRGBA } from 'src/helpers/color-helper';

type Props = {
  settings: Object
};

type ComposedProps = Props & WithI18nProps;

class PreviewFilter extends Component<ComposedProps, State> {
  render() {
    const { settings, i18n } = this.props;

    let {
      filterOptionFontFamily,
      filterOptionFontSize,
      filterOptionTextColor,
      filterTitleFontFamily,
      filterTitleFontSize,
      filterTitleFontTransform,
      filterTitleFontWeight,
      filterTitleTextColor
    } = settings;

    filterTitleTextColor = this.parseColor(filterTitleTextColor);
    filterOptionTextColor = this.parseColor(filterOptionTextColor);
    filterOptionFontSize = filterOptionFontSize ? parseInt(filterOptionFontSize) : 'initial';
    const marginBottom =
      filterOptionFontSize !== 'initial' ? Math.round((filterOptionFontSize * 7) / 16) : 7;

    const filterTitleStyle = {
      color: filterTitleTextColor,
      fontSize: filterTitleFontSize ? parseInt(filterTitleFontSize) : 'initial',
      fontWeight: filterTitleFontWeight ? parseInt(filterTitleFontWeight) : 'initial',
      fontFamily: filterTitleFontFamily,
      textTransform: filterTitleFontTransform
    };

    const filterOptionStyle = {
      color: filterOptionTextColor,
      fontSize: filterOptionFontSize,
      fontFamily: filterOptionFontFamily,
      marginBottom
    };

    return (
      <div className="align-center">
        <div className="content">
          <ul className="list">
            <li>
              <Icon source={CaretDownMinor} />
              <span style={filterTitleStyle}>
                {i18n.translate('AdminHTML.FilterSettings.Common.filterTitle')}
              </span>
            </li>
            <li style={filterOptionStyle}>
              {i18n.translate('AdminHTML.FilterSettings.Style.previewFilter_Item2')}
            </li>
            <li style={filterOptionStyle}>
              {i18n.translate('AdminHTML.FilterSettings.Style.previewFilter_Item3')}
            </li>
            <li style={filterOptionStyle}>
              {i18n.translate('AdminHTML.FilterSettings.Style.previewFilter_Item4')}
            </li>
            <li style={filterOptionStyle}>
              {i18n.translate('AdminHTML.FilterSettings.Style.previewFilter_Item5')}
            </li>
          </ul>
        </div>
      </div>
    );
  }

  parseColor(color) {
    if (_.has(color, 'rgb')) {
      color = stringifyRGBA(color.rgb);
    } else if (_.isString(color)) {
      color = color.replace(/\|\|/g, ', ');
    }

    return color;
  }
}

export default withI18n()(PreviewFilter);
